import {
    Component,
    HostBinding,
    inject,
    ChangeDetectionStrategy,
} from '@angular/core';
import { ScreenService, AppInfoService } from './shared/services';
import { RouterOutlet } from '@angular/router';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [RouterOutlet],
})
export class AppComponent {
    private screen = inject(ScreenService);
    appInfo = inject(AppInfoService);

    // Route protection and login/secure redirects are handled by `authGuard`
    // on the routes, so the root component no longer re-checks auth here.

    @HostBinding('class') get getClass() {
        return Object.keys(this.screen.sizes)
            .filter((cl) => (this.screen.sizes as any)[cl])
            .join(' ');
    }
}
